import React from "react";

const LOGO_SRC = "/hss-feed-logo-full.png";

// Small logo used in the navbar and footer (real reference wordmark, cropped tight).
const Logo = ({ height = 30, className = "" }) => (
  <img
    src={LOGO_SRC}
    alt="HSS Feed"
    style={{ height, width: "auto" }}
    className={`object-contain ${className}`}
  />
);

// Large hero wordmark using the real reference logo image.
export const LogoMark = ({ className = "" }) => (
  <img
    src={LOGO_SRC}
    alt="HSS Feed"
    width={520}
    height={260}
    className={`h-auto w-56 sm:w-64 ${className}`}
    style={{ filter: "drop-shadow(0 0 22px rgba(216,180,254,0.25))" }}
  />
);

export default Logo;
